import { render, staticRenderFns } from "./order_step2.vue?vue&type=template&id=7c1b2654&scoped=true&"
import script from "./order_step2.vue?vue&type=script&lang=js&"
export * from "./order_step2.vue?vue&type=script&lang=js&"
import style0 from "./order_step2.vue?vue&type=style&index=0&id=7c1b2654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b2654",
  null
  
)

export default component.exports